var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowURightDown = function SvgIconArrowURightDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.083 21.924a1 1 0 0 0 .324-.217l4.5-4.5a1 1 0 0 0-1.414-1.414L16.7 18.586V8.25a6.25 6.25 0 0 0-12.5 0v8.25a1 1 0 1 0 2 0V8.25a4.25 4.25 0 1 1 8.5 0v10.336l-2.793-2.793a1 1 0 0 0-1.414 1.414l4.5 4.5M14.995 21.71a1 1 0 0 0 1.088.214"
  }))));
};
export default SvgIconArrowURightDown;